import { Button, Typography } from "@material-ui/core"
import { CarModelTopBanner, ImageModel } from "api"
import { Desktop, Mobile } from "common/MediaQueries"
import NextImage from "common/bit/NextImage"
import NextLink from "common/bit/NextLink"
import { isValidMediaUrl } from "common/isValidMediaUrl"
import styled from "styled-components"
import { HomePageContainer } from "theme/shared"

const StyledWrapper = styled.div`
  position: absolute;
  background-color: ${(p) => p.theme.colors.headerColor};
  z-index: 2;
  width: 100%;
`

const StyledContainer = styled(HomePageContainer)`
  background-color: ${(p) => p.theme.colors.headerColor};
  z-index: 2;
  position: relative;
  padding-top: 36px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: 16px;
  }
`

const StyledTopBanner = styled.div<{ $bgColor?: string }>`
  background: linear-gradient(
      0deg,
      rgba(3, 47, 76, 0.2) 0%,
      rgba(3, 47, 76, 0.2) 100%
    ),
    rgba(255, 255, 255, 0.12);
  ${(p) => p.$bgColor && `background-color: ${p.$bgColor};`}
  margin-top: 36px;
  height: 280px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  padding: 8px 16px 16px 16px;

  gap: 16px;
  z-index: 2;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: 260px;

    padding: 16px 16px 32px 16px;
  }
`
const StyledImageWrapper = styled.div`
  position: absolute;
  inset: 0;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 55%;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    inset-block-start: 20px;
  }
`
const StyledContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`
const StyledTypography = styled(Typography)<{ component?: string }>`
  position: relative;
  margin-bottom: auto;
  line-height: 1.2;
  p {
    margin: 0;
  }
`
// const StyledTypographySubtitle = styled(Typography)`
//   position: relative;
// `
const StyledButton = styled(Button)`
  position: relative;
`

const BannerImage = ({ image }: { image: ImageModel }) => (
  <NextImage
    image={image}
    priority
    cover={false}
    objectPosition="bottom right"
  />
)

type Props = {
  data: CarModelTopBanner
}

const TopBanner = ({ data }: Props) => {
  if (!data) return null
  const {
    imageMob,
    imageWeb,
    buttonText,
    buttonUrl,
    isActive,
    titleWeb,
    titleMob,
    color,
    isButtonActive,
  } = data

  if (!isActive) return null
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledTopBanner $bgColor={color}>
          {isValidMediaUrl(imageMob?.imageUrl) && (
            <Mobile aboveTheFold>
              <StyledImageWrapper>
                <BannerImage image={imageMob} />
              </StyledImageWrapper>
            </Mobile>
          )}
          {isValidMediaUrl(imageWeb?.imageUrl) && (
            <Desktop aboveTheFold>
              <StyledImageWrapper>
                <BannerImage image={imageWeb} />
              </StyledImageWrapper>
            </Desktop>
          )}
          <StyledContent>
            <Mobile>
              {titleMob && (
                <StyledTypography
                  variant="h2"
                  color="secondary"
                  align="center"
                  component="div"
                  dangerouslySetInnerHTML={{ __html: titleMob }}
                />
              )}
            </Mobile>
            <Desktop>
              {titleWeb && (
                <StyledTypography
                  variant="h2"
                  color="secondary"
                  align="center"
                  component="div"
                  dangerouslySetInnerHTML={{ __html: titleWeb }}
                />
              )}
            </Desktop>
            {isButtonActive && (
              <NextLink href={buttonUrl} passHref>
                <StyledButton>{buttonText}</StyledButton>
              </NextLink>
            )}
          </StyledContent>
        </StyledTopBanner>
      </StyledContainer>
    </StyledWrapper>
  )
}

export default TopBanner
